'use strict';

var cov_2lg39acsvc = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/projectsList/projectsList.js',
        hash = 'c2a8733ce26971840127bd3596f0914b56a73f4e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/projectsList/projectsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 61
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 41
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 30
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 51
                    },
                    end: {
                        line: 7,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 64
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 11
                    },
                    end: {
                        line: 9,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsListController = function () {
    function ProjectsListController(NewProjectModalService) {
        _classCallCheck(this, ProjectsListController);

        cov_2lg39acsvc.f[0]++;
        cov_2lg39acsvc.s[0]++;

        this.NewProjectModalService = NewProjectModalService;
    }

    _createClass(ProjectsListController, [{
        key: 'displayNewProjectModal',
        value: function displayNewProjectModal() {
            var _this = this;

            cov_2lg39acsvc.f[1]++;
            cov_2lg39acsvc.s[1]++;

            this.NewProjectModalService.display().then(function (project) {
                cov_2lg39acsvc.f[2]++;
                cov_2lg39acsvc.s[2]++;

                _this.projects.$add(project);
            }, function () {
                cov_2lg39acsvc.f[3]++;
            });
        }
    }]);

    return ProjectsListController;
}();

cov_2lg39acsvc.s[3]++;


angular.module('app').component('projectsList', {
    templateUrl: 'app/components/projectsList/projectsList.html',
    controller: ProjectsListController,
    bindings: {
        projects: '<'
    }
});